import { render, staticRenderFns } from "./CpoPrivateAccessModal.vue?vue&type=template&id=ec193174"
import script from "./CpoPrivateAccessModal.vue?vue&type=script&lang=js"
export * from "./CpoPrivateAccessModal.vue?vue&type=script&lang=js"
import style0 from "./CpoPrivateAccessModal.vue?vue&type=style&index=0&id=ec193174&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports